// extracted by mini-css-extract-plugin
export default {"root":"PastClassesVisibility_root__1ryjx","title":"PastClassesVisibility_title__atmey","label":"PastClassesVisibility_label__0noUs"};